namespace Client.InfrastructureTypes

[<RequireQualifiedAccess>]
module Boolean =

    let applyIfTrue f boolean data = if boolean then f data else data